/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/strobe/strobe.d.ts" />

namespace Application.Directives {
    'use strict';

    import Utils = Application.Common.Utils;
    /**
     * Factory callback type
     */
    declare type VideoPlayerDirectiveCb = ($timeout: angular.ITimeoutService,
                                           $interval: angular.IIntervalService,
                                           connectionRoomService: Services.ConnectionRoomService,
                                           modalService: ngModal.IModalService,
                                           messageTranslationsService: Services.MessageTranslationsService,
                                           userService: Services.UserService,
                                           videoFeedService: Services.VideoFeedService) => VideoPlayerDirective;

    /**
     * Custom scope
     */
    export interface IVideoPlayerScopeDef {
        streamUrl: string;
        streamType: string;
        autoplay: string;
        loop: string;
        live: string;
        videoScaling: string;
        showThumb: string;
        streamPipeId: string;
        onVideoPlayAttempt: string;
        onVideoPlayError: string;
        onPause: string;
        // audioStatus: string;
        audioInfo1: string;
        audioInfo2: string;
        properThumbnail: string;
        properVideo: string;
        blockId: string;
        srtUrl: string;
    }

    /**
     * Custom scope
     */
    export interface IVideoPlayerScope extends ng.IScope {
        THUMBNAIL_FAIL_IMG: string;
        THUMBNAIL_NO_THUMB_IMG: string;
        streamUrl: string;
        streamType: string;
        autoplay: boolean;
        loop: boolean;
        live: boolean;
        videoScaling: string;
        showThumb: boolean;
        thumbEnabled: boolean;
        type: string;
        playerId: number;
        /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
        clickThumb: () => void;
        reloadPlayer: () => void;
        backToThumbMode: () => void;
        pausedBackToThumbMode: () => void;
        strobePlayer: StrobePlayer;
        initStrobe: () => void;
        reloadStrobe: () => void;
        thumbnail: string;
        streamPipeId: string;
        onPause: string;
        onVideoPlayAttempt: () => void;
        onVideoPlayError: () => void;
        loadVideoFeed: (initial?: boolean) => void;
        loadThumbnails: () => void;
        setVuHeight: () => void;
        videofeed: Models.IVideoFeed;
        thumbnailTimer: angular.IPromise<void>;
        videofeedTimer: angular.IPromise<void>;
        // audioStatus: boolean;
        audioInfo1: Models.IAudioInfo;
        audioInfo2: Models.IAudioInfo;
        doubleAudioLevel: () => boolean;
        properThumbnail: boolean;
        properVideo: boolean;
        allowStreamPlay: boolean;
        blockId: number;
        srtUrl: string;
    }

    export class VideoPlayerDirective implements ng.IDirective {
        public static $name: string = "videoPlayer";
        public static $inject: string[] = [];

        private static THUMBNAIL_LOADING_IMG: string = "images/thumbnail-loading.png";
        private static THUMBNAIL_FAIL_IMG: string = "images/thumbnail-fail.png";
        private static THUMBNAIL_NO_THUMB_IMG: string = "images/thumbnail-no-thumb.png";

        public link: (scope: IVideoPlayerScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/video-player-directive.html';
        public scope: IVideoPlayerScopeDef = {
            streamUrl: '@',
            streamType: '@?',
            autoplay: '=?',
            loop: '=?',
            live: '=?',
            videoScaling: '@?',
            showThumb: '=?',
            streamPipeId: '@?',
            onVideoPlayAttempt: '&',
            onVideoPlayError: '&',
            onPause: '@?',
            // audioStatus: '=',
            audioInfo1: '=',
            audioInfo2: '=?',
            properThumbnail: '=?',
            properVideo: '=?',
            blockId: '=?',
            srtUrl: '=?',
        };

        private THUMBNAIL_TIMER_MS: number = 4000;
        private VIDEOFEED_TIMER_MS: number = 5000;

        /**
         * Factory for the directive
         */
        public static Factory(): VideoPlayerDirectiveCb {
            let directive: VideoPlayerDirectiveCb = ($timeout: angular.ITimeoutService,
                                                     $interval: angular.IIntervalService,
                                                     connectionRoomService: Services.ConnectionRoomService,
                                                     modalService: ngModal.IModalService,
                                                     messageTranslationsService: Services.MessageTranslationsService,
                                                     userService: Services.UserService,
                                                     videoFeedService: Services.VideoFeedService ) => {
                return new VideoPlayerDirective($timeout, $interval, connectionRoomService, modalService,
                                                messageTranslationsService, userService, videoFeedService);
            };
            directive.$inject = ['$timeout', '$interval', 'connectionRoomService', 'ModalService', 
                                 'messageTranslationsService', 'userService', 'videoFeedService'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($timeout: angular.ITimeoutService,
                    $interval: angular.IIntervalService,
                    connectionRoomService: Services.ConnectionRoomService,
                    modalService: ngModal.IModalService,
                    messageTranslationsService: Services.MessageTranslationsService,
                    userService: Services.UserService,
                    videoFeedService: Services.VideoFeedService) {

            VideoPlayerDirective.prototype.link = (scope: IVideoPlayerScope, element: JQuery, attrs: ng.IAttributes) => {
                if (scope.properThumbnail === undefined) scope.properThumbnail = true;
                if (scope.properVideo === undefined) scope.properVideo = true;
                this.init(scope);

                scope.doubleAudioLevel = (): boolean => {
                    if (scope.audioInfo2 !== undefined && scope.audioInfo2.enabled === true) {
                        return true;
                    } else {
                        return false;
                    }
                };

                scope.initStrobe = (): void => {
                    // recreates the DOM for the strobe player to be created again
                    let parent: JQuery = $('#player_' + scope.playerId).parent();
                    $('#player_' + scope.playerId).remove();
                    scope.playerId = Common.Utils.randomNumber(100000000);
                    parent.append(`<div class="video-player" id="player_${scope.playerId}">
                                    <div id="inner_player_${scope.playerId}" />
                                </div>`);

                    scope.strobePlayer = new StrobeMediaPlayback('inner_player_' + scope.playerId,
                                                                 scope.streamUrl,
                                                                 scope.autoplay,
                                                                 scope.live);
                    if (scope.showThumb) {
                        scope.strobePlayer.registerOnRemoved(scope.backToThumbMode);
                        if (scope.onPause === "backToThumb")
                            scope.strobePlayer.registerOnPaused(scope.pausedBackToThumbMode);
                    } else {
                        scope.strobePlayer.registerOnRemoved(scope.reloadPlayer);
                    }

                    scope.strobePlayer.init();
                };

                scope.reloadPlayer = (): void => {
                    if (scope.onVideoPlayError !== undefined) {
                        scope.onVideoPlayError();
                    }

                    $timeout(() => {
                        if (scope.strobePlayer) {
                            scope.strobePlayer.destroy();
                        }

                        scope.initStrobe();
                    });
                };

                scope.pausedBackToThumbMode = (): void => {
                    scope.strobePlayer.destroy();
                    $('#player_' + scope.playerId).remove();
                    scope.thumbEnabled = true;
                    this.initVideoFeed(scope, $interval);
                };


                scope.backToThumbMode = (): void => {
                    if (scope.onVideoPlayError !== undefined) {
                        scope.onVideoPlayError();
                    }

                    scope.strobePlayer.destroy();
                    $('#player_' + scope.playerId).remove();
                    scope.thumbEnabled = true;
                    this.initVideoFeed(scope, $interval);
                    messageTranslationsService.alertOnError('There are problems with the video stream. Playback stopped.', 'bottom-center');
                };

                scope.clickThumb = (): void => {
                    scope.allowStreamPlay = userService.getCurrentUser().authorities.some((auth: Models.IAuthority) => {
                        return auth.authority === 'ROLE_ADMIN';
                    });
                    if (scope.allowStreamPlay) {
                        modalService.showModal({
                            templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                            controller: Application.Controllers.ConfirmModalController.$name,
                            inputs: {
                                title: 'Stream play',
                                description: "Playing the stream could affect the ongoing transmission. Do you want to continue?",
                                name: '',
                                type: 'warning',
                            },
                        }).then((modal: ngModal.IModalObject) => {
                            let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                            modalElem.show();
                            modal.close.then((result: Object) => {
                                modalElem.hide();
                                if (result) {
                                    if (scope.thumbnailTimer)
                                        $interval.cancel(scope.thumbnailTimer);
                                    if (scope.videofeedTimer)
                                        $interval.cancel(scope.videofeedTimer);
                                    scope.thumbEnabled = false;

                                    if (scope.onVideoPlayAttempt !== undefined) {
                                        scope.onVideoPlayAttempt();
                                    }

                                    $timeout(() => {
                                        scope.initStrobe();
                                    });
                                }
                            });
                        });
                    } else {
                        modalService.showModal({
                            templateUrl: Application.Controllers.InfoModalController.templateURL,
                            controller: Application.Controllers.InfoModalController.$name,
                            inputs: {
                                title: 'Stream play',
                                description: "Playing the stream is only allowed for Administrator profiles",
                            },
                        }).then((modal: ngModal.IModalObject) => {
                            let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.InfoModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                            modalElem.show();
                            modal.close.then((result: Object) => {
                                modalElem.hide();
                            });
                        });
                    }
                };

                scope.$on('$destroy', () => {
                    if (scope.strobePlayer)
                        scope.strobePlayer.destroy();

                    if (scope.thumbnailTimer)
                        $interval.cancel(scope.thumbnailTimer);

                    if (scope.videofeedTimer)
                        $interval.cancel(scope.videofeedTimer);
                });

                scope.THUMBNAIL_FAIL_IMG = VideoPlayerDirective.THUMBNAIL_FAIL_IMG;
                scope.THUMBNAIL_NO_THUMB_IMG = VideoPlayerDirective.THUMBNAIL_NO_THUMB_IMG;                
                scope.thumbnail = VideoPlayerDirective.THUMBNAIL_LOADING_IMG;

                scope.loadThumbnails = () => {
                    // reloads the thumbnail, if available, with a new timestamp
                    if (scope.videofeed && scope.videofeed.status !== Models.VideoFeedStatus.ERROR) {
                        if (scope.videofeed.thumbnailUrl !== "") {
                            if (scope.videofeed.forceRefreshThumbnail)
                                scope.thumbnail = scope.videofeed.thumbnailUrl + "?&" + Common.Utils.getCurrentTimestamp();
                            else
                                scope.thumbnail = scope.videofeed.thumbnailUrl;
                        } else {
                            scope.thumbnail = VideoPlayerDirective.THUMBNAIL_FAIL_IMG;
                        }
                    }
                };

                scope.loadVideoFeed = (initial?: boolean): void => {
                    if (initial) {
                        // initial loading: get video feed and thumbnails as soon as possible
                        if (scope.blockId) {
                            videoFeedService.getVideoFeedByBlockIdNoList(String(scope.blockId))
                                .then((videoFeed: Models.VideoFeed) =>
                                    this.updateVideoFeed(scope, videoFeed, true)
                                );
                        } else {
                            connectionRoomService.getVideoFeedPromiseByStreamPipeIdNoList(scope.streamPipeId)
                                .then((videoFeed: Models.VideoFeed) =>
                                    this.updateVideoFeed(scope, videoFeed, true)
                                );
                        }
                    } else {
                        if (scope.blockId) {
                            videoFeedService.getVideoFeedByBlockId(String(scope.blockId))
                                .then((videoFeed: Models.VideoFeed) =>
                                    this.updateVideoFeed(scope, videoFeed, false)
                                );
                        } else {
                            connectionRoomService.getVideoFeedPromiseByStreamPipeId(scope.streamPipeId)
                                .then((videoFeed: Models.VideoFeed) =>
                                    this.updateVideoFeed(scope, videoFeed, false)
                                );
                        }
                    }

                };

                if (scope.showThumb) {
                    this.initVideoFeed(scope, $interval);
                } else {
                    $timeout(() => {
                        scope.initStrobe();
                    });
                }
            };
        }

        private init(scope: IVideoPlayerScope): void {
            scope.playerId = Common.Utils.randomNumber(100000000);

            if (scope.streamUrl === undefined)
                scope.streamUrl = '';
            if (scope.type === undefined)
                scope.type = this.getType(scope.streamUrl);
            if (scope.autoplay === undefined)
                scope.autoplay = true;
            if (scope.loop === undefined)
                scope.loop = true;
            if (scope.live === undefined)
                scope.live = false;
            if (scope.videoScaling === undefined)
                scope.videoScaling = 'fill';
            if (scope.showThumb === undefined)
                scope.showThumb = false;
            scope.thumbEnabled = scope.showThumb;
            scope.streamType = this.getStreamType(scope.streamUrl);
        }

        private getType(streamUrl: string): string {
            streamUrl = streamUrl.toLowerCase();

            if (Common.Utils.endsWith(streamUrl, '.mp4')) {
                return "video/mp4";
            } else if (Common.Utils.startsWith(streamUrl, 'rtmp:') || Common.Utils.endsWith(streamUrl, '.flv')) {
                return "video/flv";
            } else if (Common.Utils.endsWith(streamUrl, '.mp3')) {
                return "audio/mpeg";
            } else if (Common.Utils.endsWith(streamUrl, '.m3u8')) {
                return "application/x-mpegURL";
            } else {
                return "video/mp4"; // default is mp4
            }
        }

        private getStreamType(streamUrl: string): string {
            streamUrl = streamUrl.toLowerCase();
            // only for rtmp streams
            return Common.Utils.startsWith(streamUrl, 'rtmp:') ? 'rtmp' : '';
        }

        private initVideoFeed(scope: IVideoPlayerScope, $interval: angular.IIntervalService): void {
            scope.loadVideoFeed(true);

            scope.videofeedTimer = $interval(() => {
                scope.loadVideoFeed();
            }, this.VIDEOFEED_TIMER_MS + Common.Utils.randomNumber(1000));

            scope.thumbnailTimer = $interval(() => {
                scope.loadThumbnails();
            }, this.THUMBNAIL_TIMER_MS + Common.Utils.randomNumber(1000));
        }

        private updateVideoFeed(scope: IVideoPlayerScope, videoFeed: Models.VideoFeed, loadThumbnails: boolean): void {
            if (videoFeed.status !== Models.VideoFeedStatus.ERROR && !videoFeed.equals(scope.videofeed)) {
                scope.videofeed = videoFeed;
                if (loadThumbnails) {
                    scope.loadThumbnails();
                }
            }
        }

    }
}